import {TranslateService} from '@ngx-translate/core';
import {
  ArrayTypeComponent,
  AutocompleteTypeComponent,
  ButtonToggleTypeComponent,
  DateNotBeforeFieldValidator,
  DatepickerTypeComponent,
  DateRangeValidator,
  DatetimepickerTypeComponent,
  DescriptionTypeComponent,
  EmailValidator,
  HiddenInputTypeComponent,
  MultiSchemaTypeComponent,
  NullTypeComponent,
  ObjectTypeComponent,
  PhoneTypeComponent,
  PhoneValidator,
  RepeatTypeComponent,
  SeparatorTypeComponent,
  TimepickerTypeComponent,
  VatValidator,
} from '@rg/shared-ng';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {DateTime} from 'luxon';

export function formlyConfig(translate: TranslateService) {
  return {
    validators: [
      {name: 'email', validation: EmailValidator.validator},
      {name: 'vat', validation: VatValidator.validator},
      {name: 'phone', validation: PhoneValidator.validator},
      {name: 'dateNotBefore', validation: DateNotBeforeFieldValidator.validator},
      {name: 'dateRange', validation: DateRangeValidator.validator}
    ],
    types: [
      {name: 'null', component: NullTypeComponent, wrappers: ['form-field']},
      {name: 'array', component: ArrayTypeComponent},
      {name: 'object', component: ObjectTypeComponent},
      {name: 'multischema', component: MultiSchemaTypeComponent},
      {name: 'separator', component: SeparatorTypeComponent},
      {name: 'description', component: DescriptionTypeComponent},
      {name: 'datepicker', component: DatepickerTypeComponent},
      {name: 'datetimepicker', component: DatetimepickerTypeComponent},
      {name: 'timepicker', component: TimepickerTypeComponent, wrappers: ['form-field']},
      {name: 'button-toggle', component: ButtonToggleTypeComponent},
      {name: 'autocomplete', component: AutocompleteTypeComponent, wrappers: ['form-field']},
      {name: 'hidden', component: HiddenInputTypeComponent},
      {name: 'repeat', component: RepeatTypeComponent},
      {name: 'phone', component: PhoneTypeComponent}
    ],
    validationMessages: [
      {
        name: 'required', message() {
          return translate.stream('form.validation.required');
        }
      },
      {
        name: 'type', message({schemaType}: any) {
          return translate.stream('form.validation.type', {type: schemaType[0]});
        }
      },
      {
        name: 'minLength', message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.minLength', {minLength: field.props?.['minLength']});
        }
      },
      {
        name: 'maxLength',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.maxLength', {maxLength: field.props?.['maxLength']});
        },
      },
      {
        name: 'min',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.min', {min: field.props?.['min']});
        },
      },
      {
        name: 'max',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.max', {max: field.props?.['max']});
        },
      },
      {
        name: 'maxDate',
        message(error: any, field: FormlyFieldConfig) {
          const maxDate = DateTime.fromFormat(field.formControl?.value, "yyyy-MM-dd'T'T").setLocale(translate.currentLang).toFormat('ff')
          return translate.stream('form.validation.maxDate', {date: maxDate});
        },
      },
      {
        name: 'minDate',
        message(error: any, field: FormlyFieldConfig) {
          const minDate = DateTime.fromFormat(field.formControl?.value, "yyyy-MM-dd'T'T").setLocale(translate.currentLang).toFormat('ff')
          return translate.stream('form.validation.minDate', {date: minDate});
        },
      },
      {
        name: 'multipleOf',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.multipleOf', {step: field.props?.['step']});
        },
      },
      {
        name: 'exclusiveMinimum',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.exclusiveMinimum', {step: field.props?.['step']});
        },
      },
      {
        name: 'exclusiveMaximum',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.exclusiveMaximum', {step: field.props?.['step']});
        },
      },
      {
        name: 'minItems',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.minItems', {minItems: field.props?.['minItems']});
        },
      },
      {
        name: 'maxItems',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.maxItems', {maxItems: field.props?.['maxItems']});
        },
      },
      {
        name: 'uniqueItems',
        message() {
          return translate.stream('form.validation.uniqueItems');
        },
      },
      {
        name: 'const',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.const', {constValue: field.props?.['const']});
        },
      },
      {
        name: 'email',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.email');
        }
      },
      {
        name: 'phone',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.phone');
        }
      },
      {
        name: 'vat',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('form.validation.vat');
        }
      },
      {
        name: 'dateNotBefore',
        message(error: any, field: FormlyFieldConfig) {
          const dateNotBefore = DateTime.fromISO(field.formControl?.value).setLocale(translate.currentLang).toFormat('ff')
          return translate.stream('form.validation.dateNotBefore', {dateNotBefore});
        }
      }
      // {
      //   name: 'dateRange',
      //   message(error: any, field: FormlyFieldConfig) {
      //     return translate.stream('form.validation.phone');
      //   }
      // }
    ]
  };
}
